import { render, staticRenderFns } from "./4_addressData.vue?vue&type=template&id=bf3b7c4e&scoped=true&"
import script from "./4_addressData.vue?vue&type=script&lang=js&"
export * from "./4_addressData.vue?vue&type=script&lang=js&"
import style0 from "./4_addressData.vue?vue&type=style&index=0&id=bf3b7c4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3b7c4e",
  null
  
)

export default component.exports